// Module
var code = "<admin-user-overview suspended=\"true\"></admin-user-overview> ";
// Exports
module.exports = code;